// extracted by mini-css-extract-plugin
module.exports = {"button":"index_button__sUTZi","largeButton":"index_largeButton__3XVPX"};